import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Location } from '@angular/common';
import { AppService } from 'app/services/app/app.service';
import { environment } from 'environments/environment';
import { Log } from 'app/core/logging/log';
import { SharedModule } from 'app/shared.module';
import { ConfigService } from 'app/services/config/config.service';
import { LocationAvailableModel } from 'app/models/location-available-model';
import { NavigationEnd, Router } from '@angular/router';
import { Subscription, filter } from 'rxjs';
import { MatSidenav } from '@angular/material/sidenav';

@Component({
    selector: 'app-navbar',
    templateUrl: './navbar.component.html',
    styleUrls: ['./navbar.component.scss'],
    standalone: true,
    imports: [SharedModule]
})
export class NavbarComponent implements OnInit, OnDestroy {
    @ViewChild('drawer') drawer?: MatSidenav;

    public langs = AppService.langs;
    public langSel = AppService.langSel;
    public step: string;
    public env = environment;
    private navigationSub?: Subscription;

    constructor(
        public location: Location, 
        public appService: AppService,
        public configService: ConfigService,
        private router: Router
    ) {}

    ngOnInit() {
        this.navigationSub = this.router.events
            .pipe(filter((event): event is NavigationEnd => event instanceof NavigationEnd))
            .subscribe(() => {
                this.drawer?.close();
            });
    }

    ngOnDestroy(): void {
        this.navigationSub?.unsubscribe();
    }

    isHome() {
      var titlee = this.location.prepareExternalUrl(this.location.path());
      if(titlee.charAt(0) === '#'){
          titlee = titlee.slice( 1 );
      }
        if( titlee === '/home' ) {
            
        }
        else {
            return false;
        }
    }

    isReserve() {
        var titlee = this.location.prepareExternalUrl(this.location.path());
        let found = titlee.split('/').find(f=>f=='reserve')!=undefined;
        if(found){
            return true;
        }else{
            return false;
        }
    }

    selectLang(lang:any){
        Log.debug("selectLang", {lang});
        AppService.setLang(lang);
        location.reload();
    }

    logout(){
        AppService.clearToken();
        location.reload();
    }

    getUrlBase(){
        return this.env.urlBase;
    }

    getPathHome(){
        const selectedLocation = this.appService.clientSelected;
        if(selectedLocation?.locationCode){
            return selectedLocation.locationCode;
        }
        if(this.appService.kiosk != null){
            return this.appService.kiosk;
        }
        return 'kiosk';
    }

    selectedChange($event:{location: LocationAvailableModel, autoSelected:boolean}){
        this.appService.clientSelected = $event.location;
        if(!$event.autoSelected){
            const redirect = this.router.routerState.snapshot.root.queryParams?.['redirect'];

            if (redirect) {
                this.router.navigateByUrl(redirect);
                return;
            }

            this.router.navigate([], {
                queryParams: {
                    reason: null,
                    redirect: null
                },
                queryParamsHandling: 'merge'
            }).then(() => {
                window.location.reload();
            });
        }
    }
        
}
